'use client'

import Link from "next/link"
import { FooterLinks } from "./FooterLinks"
import { SocialIcons } from "./SocialIcons"
import { motion } from "framer-motion"

export const Footer = () => {
    return (
        <footer className="bg-background pt-24 lg:pt-40 border-t border-border/40">
            <div className="container mx-auto px-6">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24 pb-24 border-b border-border/40">
                    {/* Brand Section */}
                    <div className="lg:col-span-5 space-y-10">
                        <Link
                            href="/"
                            className="group inline-flex flex-col items-start gap-1"
                        >
                            <span className="font-serif text-3xl lg:text-4xl tracking-tight text-foreground group-hover:text-primary transition-colors">
                                LQ <span className="italic">Studio</span>
                            </span>
                            <span className="text-[8px] uppercase tracking-[1em] text-muted-foreground/60 ml-0.5">
                                Photography & Creative Art
                            </span>
                        </Link>

                        <p className="text-lg text-muted-foreground font-light leading-relaxed max-w-sm italic">
                            Elevating the quiet moments through artful light and honest connection.
                        </p>

                        <div className="pt-4">
                            <SocialIcons />
                        </div>
                    </div>

                    {/* Links Section */}
                    <div className="lg:col-span-4">
                        <FooterLinks />
                    </div>

                    {/* Contact Section */}
                    <div className="lg:col-span-3 space-y-8">
                        <div className="space-y-6">
                            <h4 className="text-[10px] uppercase tracking-[0.3em] font-medium text-foreground">
                                Get in touch
                            </h4>
                            <div className="space-y-2">
                                <p className="text-xl font-serif text-foreground">leqiucreative@gmail.com</p>
                                <a
                                    href="https://wa.me/60132688407"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="block text-sm font-light text-muted-foreground hover:text-primary transition-colors"
                                >
                                    +60 13-268 8407 (Fauzi)
                                </a>
                                <a
                                    href="https://wa.me/60187882436"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="block text-sm font-light text-muted-foreground hover:text-primary transition-colors"
                                >
                                    +60 18-788 2436 (Izat)
                                </a>
                            </div>
                        </div>

                        <div className="space-y-6 pt-4">
                            <h4 className="text-[10px] uppercase tracking-[0.3em] font-medium text-foreground">
                                Visit us
                            </h4>
                            <div className="space-y-3">
                                <a
                                    href="https://maps.app.goo.gl/LAT4uhJJjyaiXhC56"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="block group"
                                >
                                    <p className="text-sm font-light text-muted-foreground leading-relaxed group-hover:text-primary transition-colors">
                                        6-2, Bangunan Pejabat,<br />
                                        Jalan Semabok, 75050 Melaka
                                    </p>
                                    <span className="text-[10px] uppercase tracking-wider text-primary mt-2 inline-block border-b border-primary/50 group-hover:border-primary transition-colors">
                                        View on Google Maps
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="py-12 flex flex-col md:flex-row justify-between items-center gap-6">
                    <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground/60">
                        &copy; {new Date().getFullYear()} LQ Studio. All rights reserved.
                    </div>

                    <div className="flex items-center gap-2">
                        <span className="text-[10px] uppercase tracking-widest text-muted-foreground/40">Powered by</span>
                        <motion.a
                            href="https://lakarsoft.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            whileHover={{ opacity: 1, x: 2 }}
                            className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground/60 font-medium hover:text-primary transition-colors"
                        >
                            LakarSoft
                        </motion.a>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer
